import React from 'react';
import { Element } from 'react-scroll';
import AMSectionTitle from './AMSectionTitle';
import BAServiceTabContent from './BAServiceTabContent.json';
import BAVerticalTab from './ba-services/BAVerticalTab';

const BAFAAbout = () => {

  return (
    <>
      <Element className="edu-about-area datatalent-section-gap home-one-cat" name="FintechAccelerator" id="FintechAccelerator">
        <div className="container eduvibe-animated-shape position-relative">
          <div className="row g-5 align-items-center">
            <div className="col-12 mt-0 p-0">
              <AMSectionTitle
                classes = "text-center"
                // slogan = "Introduction"
                title = "Fintech AI Accelerator 2025"
              />
              <p className="ba-subheading mt-4">Join M2M Tech's new Fintech AI accelerator program designed for Canadian Fintech companies ready to pilot AI-powered solutions - fast.</p>
            </div>
            <div className="col-12 col-md-6 fintech_ai_img">
              <img src={`${process.env.PUBLIC_URL}/images/business-accelerator/fintech_ai.png`} alt="fintech AI" />
            </div>
            <div className="col-12 col-md-6 mt-5 p-0">
              {/* <BAVerticalTab BAServiceTabContent={BAServiceTabContent} /> */}
              <ul className="fintech_ai_points">
                <li>Move from idea to execution, build a working MVP along with our expert AI Engineers for 3 months.</li>
                <li>No cost. No equity. Just execution.</li>
                <li>Valued at up to C$25,000 in in-kind AI development support.</li>
              </ul>
              <div className="col-12 px-0 d-flex flex-row gap-4">
                <a href="https://www.f6s.com/fintech-ai-accelerator/" className="edu-btn btn-primary">Learn More & Apply on F6S <img className="external-link" src={`${process.env.PUBLIC_URL}/images/business-accelerator/icons/maki_arrow.svg`} alt="right arrow" /></a>
              </div>
            </div>
            {/* <div className="col-12 p-0 d-flex flex-row flex-wrap">
              <div className="col-12 col-lg-6 pe-md-3">
                <div className="ba-about-left-card d-flex flex-column flex-md-row h-100">
                  <div className="col-lg-4 d-flex justify-content-center align-items-end">
                    <img src={`${process.env.PUBLIC_URL}/images/business-accelerator/innovate_faster.png`} alt="illustration" />
                  </div>
                  <div className="col-lg-8 d-flex flex-row p-4">
                    <div className="col-1">
                      <img src={`${process.env.PUBLIC_URL}/images/business-accelerator/icons/certificate.svg`} alt="illustration" />
                    </div>
                    <div className="col-11">
                      <h5 className="mb-2">Innovate Faster</h5>
                      <p className="mb-0">Bring your AI vision to life quickly with rapid prototyping, pilot testing, and hands-on expertise tailored to your business needs, helping you stay ahead of the competition.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6 ps-md-3 mt-md-0 mt-4">
                <div className="ba-about-right-card d-flex flex-column flex-md-row h-100">
                  <div className="col-lg-8 d-flex flex-row order-2 order-lg-1 p-4">
                    <div className="col-1">
                      <img src={`${process.env.PUBLIC_URL}/images/business-accelerator/icons/file.svg`} alt="illustration" />
                    </div>
                    <div className="col-11">
                      <h5 className="mb-2">Reduce Costs & Risks</h5>
                      <p className="mb-0">Leverage exclusive funding opportunities, expert mentorship, and industry-leading resources to minimize the costs and risks of AI adoption, ensuring a smooth and confident transition into AI-driven operations.</p>
                    </div>
                  </div>
                  <div className="col-lg-4 d-flex order-1 order-lg-2 justify-content-center align-items-end">
                    <img src={`${process.env.PUBLIC_URL}/images/business-accelerator/costs.png`} alt="illustration" />
                  </div>
                </div>
              </div>
            </div> */}
          </div>
          <img className="new-sticker d-none d-md-block" src={`${process.env.PUBLIC_URL}/images/business-accelerator/new_sticker_desktop.gif`} alt="illustration" />
          <img className="new-sticker d-block d-md-none" src={`${process.env.PUBLIC_URL}/images/business-accelerator/new_sticker_mobile.gif`} alt="illustration" />
        </div>
      </Element>
    </>
  )
}

export default BAFAAbout;